// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShippingNewAddress_wrapper__3d48Z","addLink":"ShippingNewAddress_addLink__2vppT"};